import { defineComponent as d, computed as r } from "vue";
import c from "./td-longtail-vue-components8.js";
import f from "./td-longtail-vue-components191.js";
const g = /* @__PURE__ */ d({
  __name: "extended-item-info",
  props: {
    isExtended: Boolean,
    bundleItem: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["select-variant"],
  setup(s) {
    const e = s, i = r(() => ({ "extended-item-info--extended": e.isExtended })), o = r(() => {
      let n;
      return Object.values(e.bundleItem.variants).find((a) => {
        const t = a?.items?.find((m) => m.active && m.teaserImage);
        return t && (n = t.teaserImage), t;
      }), n || e.bundleItem?.images?.[0];
    });
    return { __sfc: !0, props: e, dynamicClass: i, image: o, ImageElement: c, SingleItemConfigurator: f };
  }
});
export {
  g as default
};
